import MapView from "../components/map/MapView";

const Dashboard = () => {
  return (
    <div style={{ height: "100vh", width: "100%" }}>
      <MapView />
    </div>
  );
};

export default Dashboard;
